import { render, staticRenderFns } from "./PhotoInformation.vue?vue&type=template&id=c5d1dd94&scoped=true"
import script from "./PhotoInformation.vue?vue&type=script&lang=js"
export * from "./PhotoInformation.vue?vue&type=script&lang=js"
import style0 from "./PhotoInformation.vue?vue&type=style&index=0&id=c5d1dd94&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d1dd94",
  null
  
)

export default component.exports